var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSearch = function SvgSearch(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0004 9.9999C4.0004 6.6909 6.6914 3.9999 10.0004 3.9999C13.3084 3.9999 16.0004 6.6909 16.0004 9.9999C16.0004 13.3089 13.3084 15.9999 10.0004 15.9999C6.6914 15.9999 4.0004 13.3089 4.0004 9.9999M21.7054 20.2929L16.3134 14.9009C17.3664 13.5469 18.0004 11.8489 18.0004 9.9999C18.0004 5.5819 14.4184 1.9999 10.0004 1.9999C5.5814 1.9999 2.0004 5.5819 2.0004 9.9999C2.0004 14.4179 5.5814 17.9999 10.0004 17.9999C11.8484 17.9999 13.5454 17.3669 14.8984 16.3149L20.2914 21.7069C20.6804 22.0959 21.3164 22.0959 21.7054 21.7069C22.0944 21.3179 22.0944 20.6819 21.7054 20.2929"
  })));
};
export default SvgSearch;